import React, {useEffect, useContext} from "react";
// util
import Util from "../../../../util";
// context
import { CatalogueContext } from "../../../../context";
// components
import {Block, HtmlHeader, Scaffolding} from "../../../shared";
import { ActivityPackageLink, Loader } from "../../../controls";

// styling
import "./NotFound.scss";

export default function ActivityPackageNotFound() {
  // context
  const CC = useContext(CatalogueContext);

  // scroll to top when mounting
  useEffect(() => {
    Util.Scroll.scrollToTop()
  }, []);

  // pre-render
  let content = <Loader />;
  if(CC.isReady) {
    const items = CC.activityPackages.map(ap => <ActivityPackageLink key={ap._id} activityPackage={ap} />);
    content = <div className="items">{items}</div>;
  }

  // render
  return (
    <Scaffolding>
      <div id="v-activitypackage-notfound">
        <HtmlHeader title="Erlebniskombination nicht gefunden" imageUrl="" />
        <Block>
          <div className="container">
            <div className="heading">
              <h1>Leider konnte ich das nicht finden</h1>
              <p>... aber zum Glück haben wir noch viele andere Erlebnis-Kombinationen im Angebot, zum Beispiel</p>
            </div>
            {content}
          </div>
        </Block>
      </div>
    </Scaffolding>
  )
}